import { MobileNotSupported } from 'components/MobileNotSupported/MobileNotSupported';
import { useIsMobileViewport } from 'hooks/useIsMobileViewport/useIsMobileViewport';
import { useRouter } from 'next/router';
import type { ReactElement } from 'react';

// Pages that are not forms. They are informational or already responsive, so
// they keep rendering on small screens. Every other page is a questionnaire
// or certification form and is replaced by `MobileNotSupported`.
export const ALLOWED_ROUTES_FOR_MOBILE = [
  '/',
  '/404',
  '/expired',
  '/invalid',
  '/form-submitted',
];

type Props = { children: ReactElement };

// Replaces form pages with a "desktop only" message on mobile-sized
// viewports. Uses the Next.js route `pathname`, which has no basePath, so
// deploy-PR previews served under PATH_PREFIX need no special handling.
export const DeviceChecker = ({ children }: Props) => {
  const { pathname } = useRouter();
  const isMobileViewport = useIsMobileViewport();

  if (isMobileViewport && !ALLOWED_ROUTES_FOR_MOBILE.includes(pathname)) {
    return <MobileNotSupported />;
  }

  return children;
};
